import * as Api from '@ViewModels';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { useInfiniteSocialMediaPosts } from '../../../../../queries';
import { ISelectBoxOption } from '../../../SelectBox';

export function useSocialReporting({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const userSession = useUserSession();

	const [selectedUser, setSelectedUser] = React.useState<Api.UserViewModel<Api.IUser>>(null);

	const [selectedPostStatus, setSelectedPostStatus] = React.useState<Api.PostStatus[]>(null);
	const [showingSentByModal, setShowingSentByModal] = React.useState(false);
	const socialMediaPostsQuery = useInfiniteSocialMediaPosts({
		impersonationContext,
		selectedPostStatus,
		meta: {
			errorLogging: {
				category: 'useSocialReporting',
				action: 'GetSocialReports-Error',
			},
		},
		selectedUserId: selectedUser?.id,
	});
	const onSentByModalRequestClose = (user?: Api.UserViewModel, cancel?: boolean) => {
		setShowingSentByModal(false);
		if (user && !cancel) {
			setSelectedUser(user);
		}
	};
	const onUserFilterChanged = (selection: ISelectBoxOption<Api.ReportUser>) => {
		const user = new Api.UserViewModel(userSession, userSession.user);
		if (selection.value === Api.ReportUser.User) {
			setShowingSentByModal(true);
		} else if (selection.value === Api.ReportUser.Current) {
			setSelectedUser(user);
		} else {
			setSelectedUser(null);
		}
	};
	const onStatusFilterChanged = (selection: ISelectBoxOption<Api.ReportPostStatus>) => {
		switch (selection.value) {
			case 'Scheduled':
				setSelectedPostStatus([Api.PostStatus.Scheduled]);
				break;
			case 'Cancelled':
				setSelectedPostStatus([Api.PostStatus.Cancelled]);
				break;
			case 'Failed':
				setSelectedPostStatus([Api.PostStatus.Failed]);
				break;
			case 'Pending':
				setSelectedPostStatus([Api.PostStatus.Pending]);
				break;
			case 'Posted':
				setSelectedPostStatus([Api.PostStatus.PartiallySucceeded, Api.PostStatus.Succeeded, Api.PostStatus.Started]);
				break;
			default:
				setSelectedPostStatus(null);
				break;
		}
	};

	const onClearFilters = () => {
		setSelectedPostStatus(null);

		setSelectedUser(null);
	};

	return {
		onClearFilters,
		onSentByModalRequestClose,
		onStatusFilterChanged,
		onUserFilterChanged,
		selectedPostStatus,
		selectedUser,
		showingSentByModal,
		socialMediaPostsQuery,
	};
}
